export default "__VITE_ASSET__C5tuuo6q__"